import React from 'react';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectSiteFooter } from '../../../../../../store/features/siteFooter';
import SocialIcon from '../../../../../shared/SocialIcon';
import { SocialIconType } from '../../../../../../types';
import './DataCenterWorldFooterSocial.scss';

export default function DataCenterWorldFooterSocial() {
  const { social = [], hashtag } = useRootSelector(selectSiteFooter) ?? {};

  return (
    <div className="c-dcw-footer-social" data-testid="dcw-footer-social">
      <h3 className="c-dcw-footer-social__heading">Follow Us</h3>
      <ul className="c-dcw-footer-social__list">
        {social.map((item) => (
          <li key={item.type} className="c-dcw-footer-social__item">
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="c-dcw-footer-social__link"
              aria-label={item.type}
            >
              <SocialIcon type={item.type as SocialIconType} />
            </a>
          </li>
        ))}
      </ul>
      {hashtag && (
        <div className="c-dcw-footer-social__hashtag">#{hashtag}</div>
      )}
    </div>
  );
}
